var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThriveAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "99px",
    viewBox: "0 0 95 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.5746299%",
    y1: "0%",
    x2: "62.1791969%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-3",
    cx: 27.3230769,
    cy: 4.2217484,
    rx: 1.70769231,
    ry: 1.68869936
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.3%",
    y: "-29.6%",
    width: "158.6%",
    height: "159.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.9837937%",
    y1: "100%",
    x2: "39.3495145%",
    y2: "0%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH-??-(Mental-Health-Quiz)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mental-Health-Assess-LG-03.5.0",
    transform: "translate(-923.000000, -777.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "set",
    transform: "translate(822.000000, 745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(101.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-1)",
    cx: 47.2615385,
    cy: 95.3059701,
    rx: 47.2615385,
    ry: 3.69402985
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#62EBB9",
    cx: 47.2615385,
    cy: 45.8059701,
    rx: 44.3076923,
    ry: 44.3283582
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.2,
    fill: "#62EBB9",
    cx: 47.2615385,
    cy: 45.8059701,
    rx: 41.3538462,
    ry: 41.3731343
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.25,
    fill: "#62EBB9",
    cx: 47.2615385,
    cy: 45.8059701,
    rx: 35.4461538,
    ry: 35.4626866
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20.676923, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75164835,0.738461538 C3.43065698,0.738461538 0.738461538,3.43065698 0.738461538,6.75164835 L0.738461538,83.38268 C0.738461538,86.7036714 3.43065698,89.3958668 6.75164835,89.3958668 L47.8945055,89.3958668 C51.2154969,89.3958668 53.9076923,86.7036714 53.9076923,83.38268 L53.9076923,6.75164835 C53.9076923,3.43065698 51.2154969,0.738461538 47.8945055,0.738461538 L6.75164835,0.738461538 Z",
    id: "Rectangle",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 1.47692308,
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.65,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.79120879,3.37739872 L14.6144884,3.37739872 C16.2982871,3.37739872 17.8719467,4.21436692 18.8131851,5.61052179 L19.2175841,6.21037373 C20.1588225,7.6065286 21.7324821,8.4434968 23.4162808,8.4434968 L31.229873,8.4434968 C32.9136717,8.4434968 34.4873314,7.6065286 35.4285697,6.21037373 L35.8329687,5.61052179 C36.7742071,4.21436692 38.3478667,3.37739872 40.0316654,3.37739872 L47.8549451,3.37739872 C49.7193613,3.37739872 51.2307692,4.88880669 51.2307692,6.7532229 L51.2307692,83.3811055 C51.2307692,85.2455217 49.7193613,86.7569296 47.8549451,86.7569296 L6.79120879,86.7569296 C4.92679258,86.7569296 3.41538462,85.2455217 3.41538462,83.3811055 L3.41538462,6.7532229 C3.41538462,4.88880669 4.92679258,3.37739872 6.79120879,3.37739872 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 27.3230769,
    cy: 47.2835821,
    rx: 17.0769231,
    ry: 16.8869936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3230769,64.1705757 C36.7544011,64.1705757 44.4,56.6100111 44.4,47.2835821 C44.4,37.9571531 36.7544011,30.3965885 27.3230769,30.3965885 C16.1840604,30.3965885 16.1840604,47.2835821 27.3230769,47.2835821 C38.4620934,47.2835821 38.4620934,64.1705757 27.3230769,64.1705757 Z",
    id: "Oval",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 27.3230769,
    cy: 38.8400853,
    rx: 3.41538462,
    ry: 3.37739872
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#575756",
    cx: 27.3230769,
    cy: 55.7270789,
    rx: 3.41538462,
    ry: 3.37739872
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThriveAppIcon);
export default __webpack_public_path__ + "static/media/thrive-app-icon.85c8ab51009e084ce674e56aa5d7d1d8.svg";
export { ForwardRef as ReactComponent };